<template>
    <div class="row mb-4">
        <div class="col text-right mb-3">
            <el-input
                type="search"
                class=""
                clearable
                prefix-icon="el-icon-search"
                style="width: 100%"
                placeholder="Suche"
                v-model="search"
                aria-controls="datatables"
            >
            </el-input>
        </div>
    </div>
    <div class="row">
        <el-table type="index"
                  class="table-responsive"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :header-row-class-name="type === 'dark' ? 'thead-dark': ''"
                  :default-sort="{ prop: 'object_label', order: 'ascending' }"
                  empty-text="Keine Einträge vorhanden"
                  @sort-change="changeSort"
                  :data="filteredUserLicenses">
            <el-table-column prop="object_label" label="Name" min-width="170px" sortable="custom"
                             :sort-orders="['ascending', 'descending']">
                <template v-slot="{ row }">
                    {{ (row.object_label) ? row.object_label.replace('(+)', '').replace('(-)', '') : '' }}
                    <span v-if="row.object_label.includes('(+)')" class="text-success mr-2">(dazugekommen)</span>
                    <span v-if="row.object_label.includes('(-)')" class="text-danger mr-2">(weggefallen)</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import moment from 'moment';
import Modal from "@/components/Modal";
import BaseAlert from "@/components/BaseAlert";
import {
    ElTable,
    ElTableColumn,
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";

export default {
    name: 'licenses-table',
    components: {
        Modal,
        BaseAlert,
        [ElTable.name]: ElTable,
        [ElTableColumn.name]: ElTableColumn,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    props: {
        type: {
            type: String
        },
        focus: {
            type: Boolean
        },
        searchUser: {
            type: String,
            default: ''
        },
        userLicenses: {
            type: Object,
            default: {}
        },
        title: String
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        filteredUserLicenses() {
            if (this.search === '') {
                return this.userLicenses;
            } else {
                return this.userLicenses.filter(item => {
                    let props = Object.values(item);
                    return props.some(prop => !this.search.toLowerCase() || ((typeof prop === 'string') ? prop.toLowerCase().includes(this.search.toLowerCase()) : ((prop) ? prop.toString(10).toLowerCase().includes(this.search.toLowerCase()) : false)))
                });
            }
        },
    },
    methods: {
        changeSort(sort) {
            this.currentSort = (!sort.prop) ? '' : sort.prop;
            this.currentSortDir = (!sort.order) ? '' : sort.order;
            this.sortTable();
        },
        sortTable() {
            this.userLicenses.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === 'descending') modifier = -1;
                if (a[this.currentSort].toLowerCase() < b[this.currentSort].toLowerCase()) return -1 * modifier;
                if (a[this.currentSort].toLowerCase() > b[this.currentSort].toLowerCase()) return modifier;
                return 0;
            });
        },
        convertDate(date) {
            return moment(date).format('DD.MM.YYYY HH:mm');
        },
        getLicenseUser(id) {

        }
    },
    watch: {
        userLicenses() {
            this.sortTable();
        },
    },
    created() {
        this.sortTable();
    },
    data() {
        return {
            currentSort: 'object_label',
            currentSortDir: 'ascending',
            disabled: true,
            error: '',
            search: this.searchUser,
            newRequest: '',
            errorText: '',
        }
    }
}
</script>
<style scoped lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.errorText {
    color: #f5365c;
}

thead th {
    cursor: pointer;
}

</style>
